import React from "react"

import { OutboundLink } from 'gatsby-plugin-google-analytics'

import instagramLight from "../../images/social/instagram-light.svg"
import instagramDark from "../../images/social/instagram-dark.svg"
import instagramBlack from "../../images/social/insta-black.svg"

import { INSTAGRAM_URL } from "../../constants.js"

import styles from "./socialLinks.module.scss"

const images = {
  instagramLight,
  instagramDark,
  instagramBlack,
}

const InstagramLink = ({ variant }) => (
  <OutboundLink href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer">
    <img
      className={styles.img}
      src={images[`instagram${variant}`]}
      alt="Instagram Logo"
      layout="fixed"
    />
  </OutboundLink>
)

export default InstagramLink
